import React from 'react'
import BuilderBnv from '../../Components/Bulider/BuilderBnv'
import Header from '../../Components/LoginFloder/Header'
const BuilderBvn = () => {
  return (
    <div>
        <Header />
        <BuilderBnv />
    </div>
  )
}

export default BuilderBvn